import axios from "axios";

const httpClient = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
  //? window.location.origin + '/DemoService'
  ? "https://www.dts-log.com/DemoService"
  : 'http://192.168.1.81/DemoService',
  //timeout: 5000,
  headers: {
    'Content-type': 'application/json;',
  },
});

export default httpClient;
